import { render, staticRenderFns } from "./ClinicalDataManagement.vue?vue&type=template&id=79a8cc81&"
import script from "./ClinicalDataManagement.vue?vue&type=script&lang=js&"
export * from "./ClinicalDataManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports